import React, { useEffect } from 'react';
import styles from './index.module.less';
import { useStore, observer } from 'base/store'
import { RouteEnum } from 'pro/config/routers';
import { Button } from '@base/lib/Button';
import { assets } from 'pro/config/assets';
import { Image } from '@base/lib/ThemeImage';

export const HeaderCart: React.FC = observer(() => {
    const {
        miniCartStore,
        userStore: {
            state: {
                cartNum
            }
        }
    } = useStore();

    useEffect(() => {
        miniCartStore.setTotalQty(cartNum);
    }, [cartNum]);

    return (
        <Button
            className={styles.trigger}
            type={'d'}
            shape={'circle'}
            size={'small'}
            href={RouteEnum.CART}
            icon={
                <>
                    <Image
                        width={20}
                        height={18}
                        src={assets.cart}
                        fit={'contain'}
                        background={false}
                        fixed
                        pure
                    />
                    {miniCartStore.state.totalQty > 0 && (
                        <div className={styles.count}>
                            {miniCartStore.state.totalQty}
                        </div>
                    )}
                </>
            }
        />
    )
});